// extracted by mini-css-extract-plugin
export default {"container":"NSsFJ4","content":"HLZ2tc","animate":"wHCRoi","slider":"llnpCK","item":"edFi94","prev":"KFbjaT","next":"UKZ_t2"};